import { GEOAPIFY_API_KEY } from '../constants/placeTypes';

interface Location {
  lat: number;
  lng: number;
}

// Fetch 10-minute walking isochrone from Geoapify API
export const fetchIsochrone = async (location: Location): Promise<any> => {
  const { lat, lng } = location;
  const url = `https://api.geoapify.com/v1/isoline?lat=${lat}&lon=${lng}&type=time&mode=walk&range=600&apiKey=${GEOAPIFY_API_KEY}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Geoapify API returned status: ${response.status}`);
    }
    const data = await response.json();

    if (data && data.features && data.features.length > 0) {
      return data;
    } else {
      throw new Error('No isochrone data received from API');
    }
  } catch (error) {
    console.error('Error fetching isochrone data:', error);
    throw error;
  }
};
